export default "__VITE_ASSET__DYtIWAct__"